"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalendarContextProvider = exports.CalendarContextConsumer = void 0;
var _react = require("react");
const calendarContext = /*#__PURE__*/(0, _react.createContext)({});
var _default = exports.default = calendarContext;
const CalendarContextProvider = exports.CalendarContextProvider = calendarContext.Provider;
const CalendarContextConsumer = exports.CalendarContextConsumer = calendarContext.Consumer;